import Container from '../../../../../components/Container'
import { FormMenuFood } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const MenuFoodCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormMenuFood typeForm="create" />
  </Container>
)

export default MenuFoodCreate
